module.exports = __webpack_public_path__ + "img/tag3.2552c302.svg";